export const DEFAULT_PAGE_WIDTH = 793; // WeasyPrint generates A4 pdf files with 793px width

export const SPACE_BETWEEN_PAGES = 30;
export const SPACE_BETWEEN_PAGES_WITHOUT_PADDINGS = 20;
export const SPACE_BETWEEN_DRAG_COEFFICIENT = 2;